(ns ycweb.app.pos.admin.admin
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.util.core :as yuc]
   [ycweb.components.forms :as forms]
   [ycweb.components.wrapper :as w]
   [ycweb.components.transitions :as t]
   [ycweb.util.core :as yuc]
   [ycweb.app.pos.admin.printers.setup]
   [ycweb.app.pos.admin.printers.setup]))

(def admin-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}]))

(rum/defc admin-item [{:keys [label icon icon-size background select-fn second-card? alert?]}]
  [:a.card.u-min-height-160
   {:style {:height "auto"}
    :class
    (yuc/bem :tile [:has-shadow] :u-angled-background [] (when second-card? :or-card) []
      (when background (keyword (str "u-bg-" (name background)))) [])
    :on-click select-fn}
   [:span.tile__content
    [:span.tile__icon-wrapper
     [:i.tile__icon
      {:class (yuc/bem :icon [(or icon-size :2-2) icon :large :block])}]]
    [:span.tile__text label]
    (when alert?
      [:div.tile__alert
       [:i.icon.icon--block.icon--error.icon--3-2]])]])

(rum/defc screen-start < rum/reactive [app-atom]
  (let [blitz? (cmn/curact app-atom :blitz?)]
    (w/wrapper app-atom (str (if blitz? "Warehouse" "Store") " Admin") {}
      [[:nav
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center
         {:class (yuc/bem :heading [:standard])}
         "What would you like to do?"]

        (->>
          [{:label "Print Labels" :icon :label :icon-size :3-2 :background :mint-green
            :select-fn #(t/transition-next app-atom :store-admin/printer-labels)}

           (when (not blitz?)
             {:label "Store Printers" :icon :robot :icon-size :3-2 :background :asphalt-light :second-card? true
              :select-fn #(t/transition-next app-atom :store-admin/printers)})

           (when (not blitz?)
             {:label "Thermal Printers" :icon :print :icon-size :3-2 :background :plum-light :second-card? true
              :select-fn #(t/transition-next app-atom :store-admin/test-thermal-printers)})

           {:label "Printer Setup" :icon :wrench :icon-size :3-2 :background :purple :second-card? true
            :select-fn #(t/transition-next app-atom :store-admin/printer-setup)}]
          (remove nil?)
          (map-indexed #(rum/with-key (admin-item %2) %1)))]]

      []

      [])))

(defmethod flow/render-screen :admin-management [app-atom]
  (screen-start app-atom))